export enum UserTypeEnum {
  Corporate = 'Corporate',
  Admin = 'PartnerAdmin',
  Operator = 'PartnerMember',
  PartnerMemberFin = 'PartnerMemberFin',
  CorporateSupport = 'CorporateSupport'
}
